export const FORGOT_PASSWORD_MAX_LENGTH = 64
export const FORGOT_PASSWORD_MIN_LENGTH = 6
